import {Component, Input, OnChanges} from '@angular/core';
import {AuditLogFilterPipe} from '../../audit-log/helper/audit-log-filter.pipe';
import {AuditLogVO} from '../../../generate/AuditLogVO';

@Component({
    selector: 'lib-audit-log',
    templateUrl: './audit-log.component.html',
    styleUrls: ['./audit-log.component.scss'],
    standalone: false
})
export class AuditLogComponent implements OnChanges {

  @Input()
  auditLog: AuditLogVO[];

  @Input()
  domainName: string;

  auditLogFilterPipe = new AuditLogFilterPipe();

  constructor() {
  }

  ngOnChanges(changes: any): void {
  }


}
